'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import { gsap, ScrollTrigger } from '@/lib/gsap';
const Header = () => {
  const $ = _c(4);
  const sectionRef = useRef(null);
  const pinRef = useRef(null);
  const titleRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      ScrollTrigger.create({
        trigger: sectionRef.current,
        start: "top top",
        end: "+=160%",
        pin: pinRef.current,
        pinSpacing: true
      });
      gsap.fromTo(titleRef.current, {
        scale: 1.5,
        opacity: 1,
        skewY: 0
      }, {
        scale: 0.95,
        opacity: 0.7,
        skewY: 2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top+=5% top",
          end: "top+=150% top",
          scrub: 0.4
        }
      });
      gsap.set(titleRef.current, {
        transformOrigin: "50% 50%",
        willChange: "transform"
      });
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useGSAP(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().getFullYear();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentYear = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section ref={sectionRef} className="min-h-screen"><div ref={pinRef} className="grid h-screen place-content-center"><h4 ref={titleRef} className="font-primary text-center text-4xl leading-[0.8] font-black lg:text-8xl">SELECTED {t2} WORKS <br /> (2024—{currentYear})</h4></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default Header;